import { createSlice } from "@reduxjs/toolkit"


var data=[]


if (localStorage.getItem("warehouse") !== null && localStorage.getItem("warehouse") !== undefined && localStorage.getItem("warehouse") !== "") {

    data = JSON.parse(localStorage.getItem("warehouse"))

}


const Insider = createSlice({

    name: "todos",
    initialState: data,
    reducers: {
        getwarehouse: (state, action) => {
            localStorage.setItem("warehouse", JSON.stringify(action.payload.data))
            state = action.payload.data
            return state
        
        },

    },

})

export const { seedetails, home, getwarehouse } = Insider.actions;
export default Insider.reducer;